import React from "react";
import { connect } from "react-redux";
import FormularioRegistroExpress from "./registro-express.frm";

const mapState = (state) => {
	return {
		loader: state.global.loader
	};
};

const mapDispatch = (dispatch) => {
	return {
		showLoad: () => {
			dispatch({ "type": "LOADER_SHOW" });
		}
	};
};

class Flujo extends React.Component {

	componentWillMount = () => {
		localStorage.setItem("hashOne", this.props.hashOne);
	}

    render() {
        return (
			<div>
				<div style={{background: "white"}}>
					<FormularioRegistroExpress />
				</div>
			</div>
        );
    }
}

export default connect(mapState, mapDispatch)(Flujo);


// WEBPACK FOOTER //
// ./src/gnp-registro-express/flujo.cmpt.js